import type { ReferentialityPluginOptions } from '@atlassian/editor-referentiality';
import type { ReferentialityContext } from '@atlassian/editor-referentiality/types';

interface Props {
	options: {
		referentialityContext: Omit<ReferentialityContext, 'plugin'>;
	};
}

export function referentialityPluginOptions({ options }: Props): ReferentialityPluginOptions {
	return {
		api: options.referentialityContext.api ?? undefined,

		// A spread operator of the options.referentialityContext.options was previously used here, now they're all explicitly listed out to make the code more readable.
		appearance: options.referentialityContext.options.appearance,
		extensionHandlers: options.referentialityContext.options.extensionHandlers,
		externalObservers: options.referentialityContext.options.externalObservers,
		nodeNameCallback: options.referentialityContext.options.nodeNameCallback,
		nodeFocusCallback: options.referentialityContext.options.nodeFocusCallback,
		editorAnalyticsAPI: options.referentialityContext.options.editorAnalyticsAPI,
		editorView: options.referentialityContext.options.editorView,
		featureFlags: options.referentialityContext.options.featureFlags,
		__livePage: options.referentialityContext.options.__livePage,
		__rendererExtensionOptions: options.referentialityContext.options.__rendererExtensionOptions,
		extensionViewportSizes: options.referentialityContext.options.extensionViewportSizes,
	};
}
